import { graphic } from "./Graphic";
import { graphicEvents, SAVE_ENTITIES } from "./GraphicEvents";
import { selection } from "./editions/selection/Selection";


class StateManager {

    constructor() {
        this.stack = [];
        this.cursor = 0;
    }

    save() {
        return; // Disable state manager

        this.cursor = 0;
        let props = [];
        graphic.entityManager.forEach(null, entity => {
            props.push(entity.getProps());
        });
        const string = JSON.stringify(props);
        if (!this.stack.length || (this.stack.length && string !== this.stack[this.stack.length - 1])) {
            this.stack.push(string);
        }
    }

    prev() {
        return; // Disable state manager

        if (!selection.isEmpty) {
            selection.destroy();
        }

        this.cursor--;
        this.resetAt(this.stack.length + this.cursor);
    }

    resetAt(index) {
        if (!this.stack[index]) return;

        const stack = JSON.parse(this.stack[index]);

        const entities = [];
        stack.forEach(props => {
            const entity = graphic.entityManager.get(`${props.type.toLowerCase()}s`, props.id);
            if (!entity) return;

            const hasChange = JSON.stringify(entity.getProps()) !== JSON.stringify(props);
            if (!hasChange) return;

            entity.updateFromProps(props);
            entities.push(entity);
        });

        if (entities.length) graphicEvents.trigger(SAVE_ENTITIES, { entities });
    }
}

export const stateManager = new StateManager();